module.exports = __webpack_public_path__ + "media/PAG88-06.a3b2056c.mp3";